<template>
    <div class="p-contact__form bg-prim-light is-rounded">
        <loader v-if="loading"></loader>
        <div class="mw-570 py-5 px-3 px-md-0 mx-auto">
            <div class="text-center">
                <h1 class="c-ttl c-ttl--mdp">{{ title }}</h1>
                
                <p class="mt-0 fw-r">{{ subtitle }}</p>
            </div>

            <form method="post" @submit.prevent="submit">
                <div class="form-group">
                    <label for="contactName" class="sr-only">Your name</label>
                    <input id="contactName"
                        class="form-control"
                        placeholder="Your name"
                        type="text"
                        v-model="form.name"
                        required />
                </div>
                
                <div class="form-group">
                    <label for="contactEmail" class="sr-only">Your email</label>
                    <input id="contactEmail"
                        class="form-control"
                        placeholder="Your email"
                        type="email"
                        v-model="form.email"
                        required />
                </div>
                
                <div class="form-group">
                    <label for="contactMessage" class="sr-only">Your message</label>
                    <textarea id="contactMessage" 
                        class="form-control" 
                        cols="30" 
                        placeholder="Your message"
                        rows="10"
                        v-model="form.message"
                        required></textarea>
                </div>
                
                <button class="btn btn-primary w-100" type="submit">Send a message</button>
            </form>
        </div>
    </div>
</template>

<script>
import Loader from '../components/Loader.vue'
import qs from 'qs'

export default {
  components: { Loader },
    props: {
        title: String,
        subtitle: String,
        nonce: String,
    },
    data() {
        return {
            loading: false,
            form: {
                name: '',
                email: '',
                message: '',
            }
        }
    },
    methods: {
        submit() {
            this.loading = true
            axios.post(venezialines.ajaxurl, qs.stringify({
                action: 'contact_form_submit',
                _ajax_nonce: this.nonce,
                name: this.form.name,
                email: this.form.email,
                message: this.form.message,
            })).then(response => {
                this.form.name = ''
                this.form.email = ''
                this.form.message = ''
                this.$swal('Success', 'Your message has been sent!', 'success')
            }).catch(err => {
                let response = err.response
                let message
                let callback
                if (response.data && response.data.data) {
                    message = Object.values(response.data.data).map(error => error.message).join("\n")
                } else if (response.data == -1) {
                    message = 'Your message could not be sent, please try again'
                    callback = () => window.location.reload()
                } else {
                    message = 'Your message could not be sent due to an unexpected error'
                }
                this.$swal('Error', message, 'error').then(() => callback && callback())
            }).finally(() => {
                this.loading = false
            })
        }
    }
}
</script>